export const ORDERS_FILTER_SELECT_DEPARTMENTS = 'ordersDepartments';
